<ng-template #actionsTemplate>
  <hard-button
    [disabled]="modalForm.invalid"
    (click)="save()"
  >
    {{ (isEditing ? "base.save" : "base.add") | hardTranslate }}
  </hard-button>
</ng-template>

<hard-modal
  [title]="(isEditing ? 'base.edit' : 'base.add') | hardTranslate"
  [actions]="actionsTemplate"
  (closeModal)="close()"
>
  <div
    class="modal"
    [formGroup]="modalForm"
  >
    <hard-form-grid
      [form]="modalForm"
      [config]="{
        params: {
          direction: 'row',
          fields: gridFields,
        },
      }"
    ></hard-form-grid>
  </div>
</hard-modal>
